import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  signInFieldValue: faker.lorem.word,
  action: 'show',
  matchOperator: 'is',
});
